export const PANEL = '/panel';
export const SCHEDULE = '/schedule';
export const SLOTS = '/slots';
export const TECHSTACKS = '/techStacks';
export const LEVELS = '/levels';
export const PROJECTS = '/projects';
export const SETTINGS = '/settings';
export const TALENT_AQUISITION = '/talentAcquisition';
